<div fxLayout="column" style="overflow-x: hidden;">

    <!--#region Header-->
    <div fxLayout="row" fxLayoutAlign="start center">
        <h2 fxFlex="100">{{title}}</h2>
        <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <!--#endregion-->

    <!--#region Row Editor-->
    <ng-container *ngIf="mode=== 'row'">
        <div fxLayout="row" fxFlex="100">
            <div fxLayout="column" fxFlex="100" fxLayoutGap="30px">

                <div fxLayout="row" fxFlex="100">
                    <div fxLayout="column" fxFlex="100" fxLayoutGap="15px">

                        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start end" fxLayoutGap="5px">
                            <mat-form-field style="width: 100%;">
                                <mat-label>
                                    Πληκτρολογήστε έναν τίτλο
                                </mat-label>
                                <input matInput style="width: 100%" [(ngModel)]="row.title.text">
                            </mat-form-field>
                        </div>

                        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start end" fxLayoutGap="5px">
                            <mat-form-field style="width: 100%;">
                                <mat-label>
                                    Πληκτρολογήστε έναν τίτλο για την Αγγλική μετάφραση
                                </mat-label>
                                <input matInput style="width: 100%" [(ngModel)]="row.title.textEN">
                            </mat-form-field>
                        </div>

                        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start end" fxLayoutGap="5px">
                                <span fxFlex="100">Χρώμα τίτλου</span>
                            <input type="color" style="width:30px; height: 30px;" [(ngModel)]="row.title.color">
                        </div>

                        <div fxLayout="row" fxFlex="100">
                            <mat-form-field appearance="outline" style="width: 100%;">
                                <mat-label>
                                    Απόστση τίτλου
                                </mat-label>
                                <input matInput style="width: 100%" [(ngModel)]="row.title.margin">
                            </mat-form-field>
                        </div>

                        <div fxLayout="row" fxFlex="100">
                            <mat-slider style="width: 100%;" min="15" max="45" step="1" [value]="currentValue(row.title.margin)" (valueChange)="sliderValueChange($event, row)">
                                <input matSliderThumb>
                            </mat-slider>
                        </div>

                    </div>
                </div>

                <div *ngIf="row.hasLink" fxLayout="row" fxFlex="100">
                    <label style="font-weight: bold; text-decoration: underline;">Η γραμμή θα εμφανίστεί μόνό για την επιλογή {{row.linkValue.value}}</label>
                </div>

                <div fxLayout="row" fxFlex="100">
                    <label>Επεξεργαστείτε τις στήλες που έχει μια γραμμή</label>
                </div>

                <div fxLayout="row" fxFlex="100" style="margin-top: 50px;">
                    <label>Η γραμμή περιέχει <b>{{row.columns}}</b> στήλες</label>
                </div>
                <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center" fxLayoutGap="15px">
                    <button mat-flat-button fxLayoutAlign="start center" (click)="addColumn()">
                        <mat-icon style="color: green">add</mat-icon>
                        Προσθήκη στήλης
                    </button>
                    <button [disabled]="row.columns === 0" mat-flat-button fxLayoutAlign="start center" (click)="removeColumn()">
                        <mat-icon style="color:red;">delete</mat-icon>
                        Αφαίρεση στήλης
                    </button>
                </div>

                <div fxLayout="row" fxFlex="100" style="margin-top: 50px;">
                    <button mat-flat-button fxLayoutAlign="center center" (click)="duplicateColumn()">
                        <mat-icon style="color:red;">content_copy</mat-icon>
                        Διπλασιασμός γράμμής
                    </button>
                </div>
            </div>
        </div>


    </ng-container>
    <!--#endregion-->

    <!--#region Control Editor-->
    <ng-container *ngIf="mode=== 'member'">
        <mat-tab-group #tabs mat-stretch-tabs *ngIf="member.controls[0].type === 'label'">
            <mat-tab>
                <ng-template mat-tab-label>
                    <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                        Ελληνικά
                    </div>
                </ng-template>
        <app-extreme-editor *ngIf="member.controls[0].type === 'label'" [value]="member.value" [isEdit]="true"
                            (htmlValueChanged)="htmlValueChanged($event)"></app-extreme-editor>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
                        Αγγλικά
                    </div>
                </ng-template>
                <app-extreme-editor *ngIf="member.controls[0].type === 'label'" [value]="member.valueEN" [isEdit]="true"
                                    (htmlValueChanged)="htmlValueChangedEnglish($event)"></app-extreme-editor>
            </mat-tab>
        </mat-tab-group>

        <div *ngIf="member.controls[0].type !== 'label'">
          <mat-form-field appearance="outline" style="width: 100%;" *ngIf="member.key">
            <mat-label>
              Κλειδί πεδίου
            </mat-label>
            <input matInput style="width: 100%" [(ngModel)]="member.key">
          </mat-form-field>
            <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center">
            <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>
                    Πληκτρολογήστε τον τίτλο του πεδίου
                </mat-label>
                <input matInput style="width: 45%" [(ngModel)]="member.label">
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="100">
                <mat-label>
                    Πληκτρολογήστε τον τίτλο του πεδίου για την Αγγλική μετάφραση
                </mat-label>
                <input matInput style="width: 45%" [(ngModel)]="member.labelEN">
            </mat-form-field>

            <div>
                <input type="color" style="width:30px; height: 30px;" [(ngModel)]="member.labelColor">
            </div>
            </div>
            <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center">

            <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>
              Κείμενο υποκατάστασης (placeholder)
            </mat-label>
            <input matInput style="width: 100%" [(ngModel)]="member.placeholder">
          </mat-form-field>

            <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>
              Κείμενο υποκατάστασης για την Αγγλική μετάφραση (placeholder)
            </mat-label>
            <input matInput style="width: 100%" [(ngModel)]="member.placeholderEN">
          </mat-form-field>
            </div>
        </div>

<!--#region Image-->
        <div *ngIf="member.controls[0].type === 'image'">
            <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>
                    Πληκτρολογήστε τον σύνδεσμο της εικόνας
                </mat-label>
                <input matInput style="width: 100%" [(ngModel)]="member.value">
            </mat-form-field>
        </div>
<!--#endregion-->

        <div *ngIf="member.controls[0].type === 'radio' || member.controls[0].type === 'dropdown'" fxLayout="row"
             fxFlex="100">
            <div fxLayout="column" fxFlex="60">
                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
                    <mat-form-field fxFlex="100" appearance="outline">
                        <mat-label>Πληκτρολογήστε την επιλογή σας</mat-label>
                        <input style="width: 100%;" matInput [(ngModel)]="option.value" (keyup.enter)="addOption()">
                    </mat-form-field>
                    <button mat-icon-button (click)="addOption()">
                        <mat-icon>send</mat-icon>
                    </button>
                </div>
            </div>

            <div fxLayout="row" fxFlex="100" style="padding: 5px; border: 1px solid lightgray;" *ngIf="member.options.length > 0">
                <div fxLayout="column" fxFlex="100">
                    <div fxLayout="row" style="width: 100%; padding: 5px; border-bottom: 1px solid lightgray;" fxLayoutAlign="center center"> <label>Επιλογές πεδίου</label></div>
                    <div fxLayout="row" style="margin-top: 5px;"></div>
                    <div fxLayout="column" style="height: 20vh; overflow-y: auto;">
                        <div fxLayout="row" *ngFor="let option of member.options" style="border-bottom: 1px solid lightgray; margin-top: 10px;" fxLayoutAlign="start center"
                        >
                            <div fxFlex="80"><label>{{option.value}}</label></div>

                            <div fxLayoutGap="2px" fxLayoutAlign="end center">
                                <button mat-icon-button (click)="moveUp(option.id)" [disabled]="shouldDisableUpButton(option.id)">
                                    <mat-icon>arrow_circle_up</mat-icon>
                                </button>
                                <button mat-icon-button [disabled]="shouldDisableDownButton(option.id)" (click)="moveDown(option.id)">
                                    <mat-icon>arrow_circle_down</mat-icon>
                                </button>

                                <button mat-icon-button (click)="removeOption(option.id)">
                                    <mat-icon style="color: red;">delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

      <div *ngIf="member.controls[0].type === 'conditional-selector'" fxLayout="row" fxFlex="100">
        <div fxLayout="column" fxFlex="100">

          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center"  fxFlex="100">
            <mat-form-field fxFlex="100" appearance="outline" style="width: 100%">
              <mat-label>Πληκτρολογήστε την επιλογή σας</mat-label>
              <input style="width: 100%;" matInput [(ngModel)]="option.value" (keyup.enter)="addOption()">
            </mat-form-field>
            <button mat-icon-button (click)="addOption()">
              <mat-icon>send</mat-icon>
            </button>
          </div>
        </div>

          <div fxLayout="row" fxFlex="100" style="padding: 5px; border: 1px solid lightgray;" *ngIf="member.options.length > 0">
            <div fxLayout="column" fxFlex="100">
              <div fxLayout="row" style="width: 100%; padding: 5px; border-bottom: 1px solid lightgray;" fxLayoutAlign="center center"> <label>Επιλογές πεδίου</label></div>
              <div fxLayout="row" style="margin-top: 5px;"></div>
              <div fxLayout="column" style="height: 20vh; overflow-y: auto;">
                <div fxLayout="row" *ngFor="let option of member.options" style="border-bottom: 1px solid lightgray; margin-top: 10px;" fxLayoutAlign="start center"
                >
                  <div fxFlex="80"><label>{{option.value}}</label></div>

                  <div fxLayoutGap="2px" fxLayoutAlign="end center">
                    <button mat-icon-button (click)="moveUp(option.id)" [disabled]="shouldDisableUpButton(option.id)">
                      <mat-icon>arrow_circle_up</mat-icon>
                    </button>
                    <button mat-icon-button [disabled]="shouldDisableDownButton(option.id)" (click)="moveDown(option.id)">
                      <mat-icon>arrow_circle_down</mat-icon>
                    </button>

                    <button *ngIf="!linking.isLinking || linking.id !== option.id" mat-icon-button (click)="link(option)">
                      <mat-icon style="color: var(--secondaryBlue);">link</mat-icon>
                    </button>

                      <button *ngIf="linking.isLinking && linking.id === option.id" mat-icon-button (click)="doneLinking()">
                          <mat-icon style="color: var(--secondaryBlue);">done</mat-icon>
                      </button>

                    <button mat-icon-button (click)="removeOption(option.id)">
                      <mat-icon style="color: red;">delete</mat-icon>
                    </button>
                  </div>
                </div>

              </div>

            </div>


          </div>

      </div>


      <div style="margin-top: 15px;">
            <mat-slide-toggle [(ngModel)]="member.shouldExport">Εξαγωγή απάντησης</mat-slide-toggle>
        </div>
        <div>
            <mat-slide-toggle [(ngModel)]="member.isRequired">Υποχρεωτικό πεδίο</mat-slide-toggle>
        </div>
        <div>
            <mat-slide-toggle [(ngModel)]="member.twoFactor.isTwoFactorField">Χρήση ως πεδίο αναγνώρισης 2 βημάτων</mat-slide-toggle>
        </div>
        <div *ngIf="member.twoFactor.isTwoFactorField">
            <mat-select [(ngModel)]="member.twoFactor.selectedType">
                <mat-option *ngFor="let type of member.twoFactor.types" [value]="type">{{type}}</mat-option>
            </mat-select>
        </div>
      <div>
            <mat-slide-toggle [(ngModel)]="member.isHidden">Κρυφό πεδίο</mat-slide-toggle>
        </div>
        <div>
            <mat-slide-toggle [(ngModel)]="member.displayOnTable">Εμφάνιση στον πίνακα</mat-slide-toggle>
        </div>
    </ng-container>
    <!--#endregion-->

    <!--#region Form Editor-->
    <ng-container *ngIf="mode !== 'row' && mode !== 'member'">

        <!--#region Title-->
        <div fxLayout="row" fxFlex="100">
            <div fxLayout="column" fxFlex="100">
                <div fxLayout="row" fxFlex="100">
                    <label>Τίτλος φόρμας</label>
                </div>

                <div fxLayout="row" fxFlex="100">
                    <mat-form-field style="width: 100%;">
                        <input style="width: 100%;" matInput [(ngModel)]="form.settings.title" placeholder="Πληκτρολογήστε ένα τίτλο για τη φόρμα σας">
                    </mat-form-field>
                </div>
            </div>
        </div>
        <!--#endregion-->

        <!--#region Row Gap-->
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center">
            <div fxLayout="column" fxFlex="90">
                Απόσταση γραμμών:
            </div>
            <div fxLayout="column" fxFlex="10">
                <mat-form-field>
                    <input matInput [(ngModel)]="form.settings.gapRow">
                </mat-form-field>
            </div>
        </div>
        <!--#endregion-->

        <!--#region Column Gap-->
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center">
            <div fxLayout="column" fxFlex="90">
                Απόσταση στηλών:
            </div>
            <div fxLayout="column" fxFlex="10">
                <mat-form-field>
                    <input matInput [(ngModel)]="form.settings.gap">
                </mat-form-field>
            </div>
        </div>
        <!--#endregion-->

        <!--#region Multilingual-->
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center">
            <span fxLayout="column" fxFlex="100">
                Πολυγλωσσικότητα:
            </span>
            <mat-slide-toggle [(ngModel)]="form.settings.language.multi"></mat-slide-toggle>
        </div>

        <div *ngIf="form.settings.language.multi" fxLayout="row" fxFlex="100" fxLayoutAlign="start center">
            <span fxLayout="column" fxFlex="100">
                Προεπιλεγμένη γλώσσα
            </span>
            <mat-form-field>
                <mat-select [(ngModel)]="form.settings.language.default">
                    <mat-option value="1">Ελληνικά</mat-option>
                    <mat-option value="2">Αγγλικά</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="form.settings.language.multi" fxLayout="row" fxFlex="100" fxLayoutAlign="start center">
            <span fxLayout="column" fxFlex="100">
                Θέση:
            </span>
            <mat-form-field>
                <mat-select [(ngModel)]="form.settings.language.position">
                    <mat-option value="start center">Αριστερά</mat-option>
                    <mat-option value="center center">Κέντρο</mat-option>
                    <mat-option value="end center">Δεξιά</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <!--#endregion-->


        <div fxLayout="row" fxFlex="100" style="margin-top: 50px;" fxLayoutAlign="start center">
            <span fxFlex="100">Ύπαρξη κωδικού 2 βημάτων</span>
            <mat-slide-toggle [(ngModel)]="form.settings.hasTwoFactor"></mat-slide-toggle>
        </div>
        <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center">
            <span fxFlex="100">Επεξεργασία μετά την υποβολή</span>
            <mat-slide-toggle [(ngModel)]="form.settings.canEditAfterSubmit"></mat-slide-toggle>
        </div>


    </ng-container>
    <!--#endregion-->

    <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center" style="margin-top: 25px; margin-bottom: 25px;">
        <button (click)="save()" mat-raised-button style="background-color: var(--secondaryBlue); color: white;">Αποθήκευση</button>
    </div>

</div>
